"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Img = _interopRequireDefault(require("../Img"));

var _icons = require("../../icons");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

class ProfileImage extends _react.default.PureComponent {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "imgRef", _react.default.createRef());

    _defineProperty(this, "_errorHandler", () => {
      this.imgRef.current.src = _icons.profileThumb;
    });
  }

  render() {
    return /*#__PURE__*/_react.default.createElement(_Img.default, _extends({
      ref: this.imgRef,
      onError: this._errorHandler
    }, this.props));
  }

}

var _default = ProfileImage;
exports.default = _default;